import Vue from 'vue';
import VueCarousel from 'vue-carousel';
import VueSocialSharing from 'vue-social-sharing';
// import Notifications from 'vue-notification';

Vue.use(VueCarousel);
Vue.use(VueSocialSharing);
// Vue.use(Notifications);
